import {
    CardCollection,
    Instance,
    Knot,
    Objekt,
    Promize,
} from '@siposdani87/sui-js';
import { app } from '../app';
import { AssetService } from '@services/assetService';
import { LanguageService } from '@services/languageService';
import { ObservationService } from '@services/observationService';
import { OrganizationService } from '@services/organizationService';
import { UtilService } from '@services/utilService';
import { initCardCollection } from '@utils/collectionSetup';
import { DashboardController } from './dashboardController';

export class ObservationsIndexByUserController extends DashboardController {
    static readonly inject = [
        'instances',
        'observationService',
        'organizationService',
        'utilService',
        'assetService',
        'languageService',
    ] as const;

    userId!: string;
    observationCardCollection!: CardCollection;

    constructor(
        instances: Instance,
        private observationService: ObservationService,
        private organizationService: OrganizationService,
        private utilService: UtilService,
        private assetService: AssetService,
        private languageService: LanguageService,
    ) {
        super(instances);
    }

    protected override _initLayout(): void {
        this.userId = this.state.getParam('userId');

        this._initToolbarButtons();
        this._initFilterForm();

        this._drawContent();
    }

    protected override _drawContent(): Promize | boolean {
        this._initObservationCardCollection();
        return true;
    }

    private _initToolbarButtons(): void {
        this.helper.fabButton('.btn-observations-new', this.dom, () => {
            this.observationService.newDialog().then(() => {
                this._drawContent();
            });
        });

        this.helper.iconButton('.btn-users-home', this.dom, () => {
            this.state.goBack('users.home');
        });
    }

    private _initObservationCardCollection(): void {
        this.observationCardCollection = initCardCollection(
            this.observationCardCollection,
            this.dom,
            '.observation-collection',
            this.observationService,
            {
                entityKey: 'observations',
                fetchData: (params) =>
                    this.observationService.getAllByUser(this.userId, params),
                extraParams: (params) => {
                    params.set('query', this.query);
                    params.set('organization_ids', this.organizationIds);
                    params.set(
                        'fields',
                        'id,short_description,photo,location.address,' +
                            this.organizationService.getAssociationTableFields(),
                    );
                },
            },
            this._observationCardKnot.bind(this),
            undefined,
            { sort: { column: 'created_at', order: 'desc' } },
        )!;
    }

    private _observationCardKnot(cardKnot: Knot, observation: Objekt): void {
        this._initObservationShowButton(cardKnot, observation);
        this._initCardButtons(cardKnot, observation);
        this.utilService.initOrganizationLink(cardKnot, observation);
    }

    private _initObservationShowButton(
        cardKnot: Knot,
        observation: Objekt,
    ): void {
        this.helper.link(
            'a.card',
            cardKnot,
            (href) => {
                this.state.go(href);
            },
            this.state.resolveUrl('observations.show', {
                observationId: observation.get<string>('id'),
            }),
        );
    }

    private _initCardButtons(cardKnot: Knot, observation: Objekt): void {
        // let actionsKnot = new Query('.actions', cardKnot).getKnot();
    }
}

export const observationsIndexByUserController = app.controller(
    'observationsIndexByUserController',
    ObservationsIndexByUserController,
);
